import * as types from './types'
import { Axios } from '../utils/Axios'
import { fetchIsUpdateAgreement } from '@/services/api.index'
import * as baseMthods from '../utils/baseMethod'

export const memberInfo = async({commit}) => {
  const res = await Axios('web/user/customer-users/self')
  commit(types.GET_MEMBERINFO, res.data)
  return res.data
}

export const courseInfo = async({commit}) => {
  const id = baseMthods.getLocalObj('memberInfo').researchGroup.id
  const res = await Axios(`web/user/customer-research-groups/${id}`)
  commit(types.GET_COURSEINFO, res.data)
  return res.data
}

export const updateAgreementAction = async ({ commit }) => {
  const { data } = await fetchIsUpdateAgreement()
  commit(types.GET_SERVICE_AGREEMENT_STATUS, {
    status: !data
  })
  return !data
}



// WEBPACK FOOTER //
// ./src/store/actions.js